export function decodeJwtPayload(token) {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(
        decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        )
    );
}

export function isTokenValid(token) {
    try {
        const payload = decodeJwtPayload(token);
        return payload.exp * 1000 > Date.now();
    } catch {
        return false;
    }
}
